/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArtifactWidgetListingDetailsContent } from './ArtifactWidgetListingDetailsContent';
import {
    ArtifactWidgetListingDetailsContentFromJSON,
    ArtifactWidgetListingDetailsContentFromJSONTyped,
    ArtifactWidgetListingDetailsContentToJSON,
    ArtifactWidgetListingDetailsContentToJSONTyped,
} from './ArtifactWidgetListingDetailsContent';

/**
 * 
 * @export
 * @interface ArtifactWidgetListingDetails
 */
export interface ArtifactWidgetListingDetails {
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetListingDetails
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetListingDetails
     */
    messageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetListingDetails
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetListingDetails
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetListingDetails
     */
    kind: ArtifactWidgetListingDetailsKindEnum;
    /**
     * 
     * @type {ArtifactWidgetListingDetailsContent}
     * @memberof ArtifactWidgetListingDetails
     */
    content: ArtifactWidgetListingDetailsContent;
}


/**
 * @export
 */
export const ArtifactWidgetListingDetailsKindEnum = {
    WidgetListingDetails: 'widget-listing-details'
} as const;
export type ArtifactWidgetListingDetailsKindEnum = typeof ArtifactWidgetListingDetailsKindEnum[keyof typeof ArtifactWidgetListingDetailsKindEnum];


/**
 * Check if a given object implements the ArtifactWidgetListingDetails interface.
 */
export function instanceOfArtifactWidgetListingDetails(value: object): value is ArtifactWidgetListingDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('messageId' in value) || value['messageId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ArtifactWidgetListingDetailsFromJSON(json: any): ArtifactWidgetListingDetails {
    return ArtifactWidgetListingDetailsFromJSONTyped(json, false);
}

export function ArtifactWidgetListingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactWidgetListingDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'messageId': json['messageId'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'kind': json['kind'],
        'content': ArtifactWidgetListingDetailsContentFromJSON(json['content']),
    };
}

export function ArtifactWidgetListingDetailsToJSON(json: any): ArtifactWidgetListingDetails {
    return ArtifactWidgetListingDetailsToJSONTyped(json, false);
}

export function ArtifactWidgetListingDetailsToJSONTyped(value?: ArtifactWidgetListingDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'messageId': value['messageId'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'kind': value['kind'],
        'content': ArtifactWidgetListingDetailsContentToJSON(value['content']),
    };
}

